import React, { useState, useEffect } from 'react';
import { useTheme, createUseStyles } from 'react-jss';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import SwiperCore, {
  Pagination,
} from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/swiper-bundle.css';

import Container from '@components/Container';
// import Audio from '@components/Base/Audio';
import PDF from '@components/Base/PDF';
// import GPS from '@components/Base/GPS';

const useStyles = createUseStyles(({
  rem,
}) => ({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: [rem(10), rem(20)],
    backgroundColor: 'rgba(255, 255, 255, 1)',
  },
  sliderContainer: {
    width: '100%',
    margin: [20, 0],
    overflowX: 'hidden',
    '& .swiper-wrapper': {
      height: rem(150),
      boxShadow: '0px 2px 6px 0px rgba(229,229,229,1)',
    },
    '& .swiper-slide': {
      overflow: 'hidden',
      height: rem(150),
      borderRadius: 8,
      border: '1px solid rgba(231, 231, 231, 1)',
      '& > img': {
        width: '100%',
        objectFit: 'cover',
      },
    },
    '& .swiper-pagination': {
      bottom: 0,
    },
  },
  sVideo: {
    width: '100%',
    height: rem(150),
    margin: '0 auto',
  },
  hidden: {
    display: 'none',
  },
}), {
  name: 'TracCarousel'
})

SwiperCore.use([Pagination]);

const TracCarousel = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const [logistics, setLogistics] = useState([]); // 物流文件
  // const [gpsInfo, setGpsInfo] = useState({});
  const [videos, setVideos] = useState([]);
  const [image, setImage] = useState({});

  // trackinfo 不同的结构
  const [tvideo, setTvideo] = useState({})
  const [trImages, setTrImages] = useState([]);

  const { t, data, belong } = props;
  const type = R.pathOr('', ['belong'])(belong);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const init = () => {
    if (data) {
      // const gps = R.pathOr({}, ['custom', 'gps'])(data);
      // setGpsInfo(gps);

      //  出货数据和其他dcp不一致
      if (type === 'trackinfo') {
        const filesInfo = R.pathOr([], ['custom', 'files'])(data);
        setLogistics(filesInfo);
        const trackvideo = R.pathOr({}, ['custom', 'trackvideo'])(data);
        setTvideo(trackvideo);
        const trackimages = R.pathOr([], ['custom', 'trackimages'])(data);
        setTrImages(trackimages);
      } else {
        const mainimage = R.pathOr({}, ['custom', 'mainimage'])(data);
        setImage(mainimage);
        const filesInfo = R.pathOr([], ['custom', 'filelist'])(data);
        setLogistics(filesInfo);
        const videolist = R.pathOr([], ['custom', 'videolist'])(data);
        setVideos(videolist);
      }
    }
  }

  // 统计非gps数据长度，如果为0，则轮播图就单个显示即可
  const calcTotalLen = () => {
    let len = 0;
    if (type === 'trackinfo') {
      len = logistics.length + trImages.length + Object.keys(tvideo).length;
    } else {
      len = logistics.length + videos.length + Object.keys(image).length;
    }
    if (len === 0) return 1;
    return 2;
  }

  useEffect(() => {
    if (data) {
      init();
    }
  }, []);

  // 物流文件
  const createLogistics = () => {
    if (!logistics) return null;
    return (logistics && logistics.length > 0) && (
      logistics.map((item, index) => (
        <SwiperSlide key={String(index)}>
          <PDF 
            t={t}
            src={R.pathOr('', ['filelocation'])(item)}
            size={1}
          />
        </SwiperSlide>
      ))
    )
  };

  // const createGps = () => {
  //   if (Object.keys(gpsInfo).length === 0) return null;
  //   return (
  //     <SwiperSlide>
  //       <GPS
  //         t={t}
  //         data={gpsInfo}
  //       />
  //     </SwiperSlide>
  //   )
  // }

  const createTrackVideo = () => {
    if (Object.keys(tvideo).length === 0) return null;
    return (
      <SwiperSlide>
        <video
          playsInline
          controls='controls'
          src={R.pathOr('', ['filelocation'])(tvideo)}
          className={classes.sVideo}
        >
          <source src={R.pathOr('', ['filelocation'])(tvideo)} type="video/mp4" />
          Your browser does not support the video element.
        </video>
      </SwiperSlide>
    )
  };

  const createDcpVideos = () => {
    if (!videos.length) return null;
    return (videos && videos.length > 0) && (
      videos.map((item, index) => (
        <SwiperSlide key={String(index)}>
          <video
            playsInline
            controls='controls'
            src={R.pathOr('', ['filelocation'])(item)}
            className={classes.sVideo}
          >
            <source src={R.pathOr('', ['filelocation'])(item)} type="video/mp4" />
            Your browser does not support the video element.
          </video>
        </SwiperSlide>
      ))
    )
  };

  const createTrckImages = () => {
    if (!trImages.length) return null;
    return (trImages && trImages.length > 0) && (
      trImages.map((item, index) => (
        <SwiperSlide key={String(index)}>
          <img src={R.pathOr('', ['filelocation'])(item)} alt='logo' width={100} height={`100%`}/>
        </SwiperSlide>
      ))
    )
  };

  const createMainImage = () => {
    if (Object.keys(image).length === 0) return null;
    return (
      <SwiperSlide>
        <img src={R.pathOr('', ['filelocation'])(image)} alt='logo' width={100} />
      </SwiperSlide>
    )
  }

  return (
    <Container className={classNames(classes.root, (calcTotalLen() === 1) && classes.hidden)}>
      <Swiper
        loop
        slidesPerView={calcTotalLen()}
        spaceBetween={10}
        noSwiping={calcTotalLen() === 1}
        noSwipingSelector='div'
        pagination={{ clickable: true }}
        className={classNames(classes.sliderContainer)}
      >
        {type === 'trackinfo' ? createTrckImages() : createMainImage()}

        {logistics.length > 0 && createLogistics()}

        {/* {gpsInfo && createGps()} */}

        {type === 'trackinfo' ? createTrackVideo() : createDcpVideos()}

        {/* <SwiperSlide>
          <Audio 
            src=''
            size={1}
          />
        </SwiperSlide>
        */}
      </Swiper>
    </Container>
  )
};

TracCarousel.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.object,
  belong: PropTypes.object.isRequired,
}

export default TracCarousel;
